var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogoSquareYellow = function SvgLogoSquareYellow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 77,
    viewBox: "0 0 78 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.953 0H.512v76.306H78V14.047C78 6.29 71.712 0 63.953 0",
    fill: "#F0AC00"
  })));
};
export { SvgLogoSquareYellow as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNzgiIGhlaWdodD0iNzciIHZpZXdCb3g9IjAgMCA3OCA3NyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik02My45NTI4IDBIMC41MTE4NzFWNzYuMzA1OUg3OFYxNC4wNDcxQzc4IDYuMjkwMjggNzEuNzExNyAwIDYzLjk1MjggMCIgZmlsbD0iI0YwQUMwMCIvPgo8L3N2Zz4K";